import classNames from 'classnames';

const styles = {
  component: classNames(
    'flex',
    'items-center',
    'justify-center',
    'absolute',
    'top-0',
    'left-0',
    'w-full',
    'h-full',
    'bg-lightGray/80',
    'backdrop-blur-sm',
  ),
};

export default styles;
